var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Users-dashboard-single-selected",
    transform: "translate(-1004.000000, -44.000000)",
    fill: "#A5A5A5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass",
    transform: "translate(1004.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.835662,18.0310421 L14.2173431,13.4137472 C15.4561987,11.9898004 16.2062542,10.131929 16.2062542,8.10133038 C16.2062542,3.63148559 12.5697494,0 8.10312708,0 C3.63229097,0 0,3.63569845 0,8.10133038 C0,12.5669623 3.63650477,16.2026608 8.10312708,16.2026608 C10.1341761,16.2026608 11.9924595,15.4527716 13.4167221,14.2141907 L18.035041,18.8314856 C18.1445997,18.94102 18.2920825,19 18.4353515,19 C18.5786205,19 18.7261033,18.9452328 18.835662,18.8314856 C19.0547793,18.6124169 19.0547793,18.2501109 18.835662,18.0310421 Z M1.13351076,8.10133038 C1.13351076,4.25920177 4.26014637,1.13747228 8.09891328,1.13747228 C11.941894,1.13747228 15.0643158,4.26341463 15.0643158,8.10133038 C15.0643158,11.9392461 11.941894,15.0694013 8.09891328,15.0694013 C4.26014637,15.0694013 1.13351076,11.943459 1.13351076,8.10133038 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9dcc68e2.svg";
export { ForwardRef as ReactComponent };